import {
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faTrashAlt,
  faDollarSign,
  faCaretDown,
  faBars,
  faSearch,
  faTimes,
  faSignOutAlt,
  faCheck,
  faPrint,
  faCalendarAlt,
  faClock,
  faBarcode,
  faScanner,
  faBadgePercent,
  faPercent,
  faBackspace,
  faEllipsisVAlt,
  faMoneyBillAlt,
  faMoneyCheckAlt,
  faCreditCard,
  faBarcodeRead,
  faQrcode,
  faCircle,
  faTags,
} from '@fortawesome/pro-light-svg-icons';
import { faLine } from '@fortawesome/free-brands-svg-icons';

const icons = [
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faCaretDown,
  faTrashAlt,
  faDollarSign,
  faBars,
  faSearch,
  faTimes,
  faSignOutAlt,
  faCheck,
  faPrint,
  faCalendarAlt,
  faClock,
  faBarcode,
  faScanner,
  faBadgePercent,
  faPercent,
  faBackspace,
  faEllipsisVAlt,
  faMoneyBillAlt,
  faMoneyCheckAlt,
  faCreditCard,
  faLine,
  faBarcodeRead,
  faQrcode,
  faCircle,
  faTags,
];

export default icons;



// WEBPACK FOOTER //
// ./src/assist/icons.js